import Immutable from 'immutable';
import { PageId } from 'records/Page';

export type ImageAlignment = {
  topleft: Coordinate;
  topright: Coordinate;
  bottomright: Coordinate;
  bottomleft: Coordinate;
};

export type ImageSource = {
  type: 'image';
  id: string;
  url: string;
  calibrationconfig: ImageCalibrationConfig;
};

type RasterSource = {
  type: 'raster';
  id: string;
  attribution: string;
  bounds: number[];
  maxZoom: number;
  minZoom: number;
  scheme: 'xyz' | 'tms';
  tiles: string[];
  url: string;
  tileSize: number;
};

export type Measurement<TUnit> = {
  unit: TUnit;
  value: number;
};

export type Scale = {
  from: Measurement<SmallUnit>;
  to: Measurement<LargeUnit>;
};

export type ImageCalibrationConfig = {
  scale: Scale;
  croppath: Point[];
  corners: ImageAlignment;
  bearing: number;
  centerpoint: Coordinate;
  creationtimestamp: number;
};

export type CreateMappedSheetVersionInput = Omit<
  ImageCalibrationConfig,
  'creationtimestamp'
>;

export interface MappedSheetVersionData {
  projectid: string;
  sheetid: string;
  pageid: string;
  imagesource: ImageSource | null;
  rastersource: RasterSource | null;
}

const defaultValues: MappedSheetVersionData = {
  projectid: '',
  sheetid: '',
  pageid: '',
  imagesource: null,
  rastersource: null,
};

export const MappedSheetVersionFactory = Immutable.Record(
  defaultValues,
  'MappedSheetVersion'
);

export class MappedSheetVersion extends MappedSheetVersionFactory {
  serialize(): MappedSheetVersionData {
    return this.toJS();
  }

  static deserialize(
    mappedSheetVersionData: MappedSheetVersionData
  ): MappedSheetVersion {
    return new MappedSheetVersion({
      ...mappedSheetVersionData,
    });
  }
}

export type MappedSheetVersionList = Immutable.List<MappedSheetVersion>;

export type MappedSheetVersionMap = Immutable.OrderedMap<
  PageId,
  MappedSheetVersion
>;
